export default __webpack_public_path__ + "assets/browser-c70fec4.svg";